import React, { useContext } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import figures1 from '../../assets/img/figures-1.svg';
import figures2 from '../../assets/img/figures-2.svg';
import figures3 from '../../assets/img/figures-3.svg';
import figures4 from '../../assets/img/figures-4.svg';
import './affiliateFiguresWidget.scss';
import { CurrencyContext } from '../../utils/currencyContext';
import getCurrencySign from '../../utils/getCurrencySign';

function AffiliateFiguresWidget() {
    const { t } = useTranslation();
    const { currentCurrency } = useContext(CurrencyContext);
    const sign = getCurrencySign(currentCurrency);
    return (
        <div className="figures-widget-wrapper">
            <Row>
                <Col xl={3} lg={3} md={6} xs={12}>
                    <div className="single-items">
                        <div className="single-items-wrapper">
                            <img src={figures1} alt="fan-fact-1" />
                        </div>
                        <h2>
                            <span>35%</span>
                        </h2>
                        <h4>{t('affiliate-page.figures-text-1')}</h4>
                    </div>
                </Col>
                <Col xl={3} lg={3} md={6} xs={12}>
                    <div className="single-items">
                        <div className="single-items-wrapper">
                            <img src={figures2} alt="fan-fact-1" />
                        </div>
                        <h2>
                            <span>€5</span>
                        </h2>
                        <h4>{t('affiliate-page.figures-text-2')}</h4>
                    </div>
                </Col>
                <Col xl={3} lg={3} md={6} xs={12}>
                    <div className="single-items">
                        <div className="single-items-wrapper">
                            <img src={figures3} alt="fan-fact-1" />
                        </div>
                        <h2>
                            <span>+500</span>
                        </h2>
                        <h4>{t('affiliate-page.figures-text-3')}</h4>
                    </div>
                </Col>
                <Col xl={3} lg={3} md={6} xs={12}>
                    <div className="single-items">
                        <div className="single-items-wrapper">
                            <img src={figures4} alt="fan-fact-1" />
                        </div>
                        <h2>
                            <span>{sign}100,000+</span>
                        </h2>
                        <h4>{t('affiliate-page.figures-text-4')}</h4>
                    </div>
                </Col>
            </Row>
        </div>
    );
}

export default AffiliateFiguresWidget;
